enum RequestStatusEnum {
  Created = 1,
  Unlocked = 2,
  Evaluated = 3,
  ComplaintFiled = 4,
  Finalized = 5,
  Draft = 6,
}

export default RequestStatusEnum;
